<template>
  <div v-clickoutside="handleClose" class="w-select">
    <input
      ref="inner-input"
      class="w-select-inner-input input"
      v-model="currentInput"
      type="text"
      :placeholder="currentPlaceholder || placeholder"
      @focus="onfocus"
      @click="handleOpen"
      @keyup.up="upEvent"
      @keyup.down="downEvent"
      @keyup.enter="enterEvent"
    />
    <div v-if="nativeValue" class="w-select-clear" @click="handleClear">x</div>
    <div v-show="showDropdown" class="w-select-dropdown">
      <div
        class="w-select-option"
        v-for="(item, index) in suggestion"
        :key="item.value"
        :class="{ isHover: hoverIndex === index }"
        @click="onChange(item)"
      >
        {{ item.label }}
      </div>
      <div v-if="!suggestion.length" class="w-select__empty">无匹配数据</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WSelect',
  props: {
    value: [String, Number],
    placeholder: String,
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentInput: '',
      currentPlaceholder: '',

      nativeValue: '',

      showDropdown: false,

      hoverIndex: -1
    };
  },
  computed: {
    selectedLabel() {
      let opt = this.options.find((d) => d.value === this.nativeValue);
      return opt ? opt.label : this.nativeValue;
    },
    suggestion() {
      if (!this.currentInput) return this.options;
      return this.options.filter((d) => d.label.includes(this.currentInput));
    }
  },
  watch: {
    value(val) {
      this.setNativeValue(val);
    }
  },
  mounted() {
    this.setNativeValue(this.value);
  },
  methods: {
    setNativeValue(val) {
      let value = val;
      if (value === undefined && value === null) value = '';
      if (value !== this.nativeValue) {
        this.nativeValue = value;
        this.currentInput = this.selectedLabel;
      }
    },
    handleInput() {
      let value = this.value;
      if (value === undefined && value === null) value = '';
      if (value !== this.nativeValue) {
        this.$emit('input', this.nativeValue);
      }
    },
    onfocus() {},
    onChange(item) {
      this.setNativeValue(item.value);
      this.handleInput();
      this.handleClose();
      this.$emit('change', item.value, item);
    },
    handleClose() {
      if (!this.showDropdown) return;
      this.showDropdown = false;
      this.currentPlaceholder = '';
      this.currentInput = this.selectedLabel;
    },
    handleOpen() {
      this.showDropdown = true;
      this.currentPlaceholder = this.selectedLabel;
      this.currentInput = '';
    },
    handleClear() {
      this.setNativeValue('');
    },
    upEvent() {
      if (this.hoverIndex > 0) {
        this.hoverIndex--;
      }
    },
    downEvent() {
      if (this.hoverIndex + 1 < this.suggestion.length) {
        this.hoverIndex++;
      }
    },
    enterEvent() {
      let opt = this.suggestion[this.hoverIndex];
      if (opt) this.onChange(opt);
      this.hoverIndex = -1;
      this.$refs['inner-input'].blur();
    }
  }
};
</script>



// WEBPACK FOOTER //
// w-select.vue?79212f7e